import { render, staticRenderFns } from "./gc-footer-item.vue?vue&type=template&id=824dfe84"
import script from "./gc-footer-item.vue?vue&type=script&lang=js"
export * from "./gc-footer-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports